import React from 'react';
import { FileText, Package } from 'lucide-react';
import { ConfirmationDialog } from './ConfirmationDialog';

interface UncheckWarningDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  onCancel: () => void;
  title: string;
  message: string;
  hasDocuments: boolean;
  hasPipes: boolean;
}

export const UncheckWarningDialog: React.FC<UncheckWarningDialogProps> = ({
  open,
  onOpenChange,
  onConfirm,
  onCancel,
  title,
  message,
  hasDocuments,
  hasPipes,
}) => {
  return (
    <ConfirmationDialog
      open={open}
      onOpenChange={onOpenChange}
      title={title}
      message={message}
      confirmLabel="Continue"
      onConfirm={onConfirm}
      onCancel={onCancel}
      note={
        <>
          <span className="font-semibold">Note:</span> Please remove the following before unchecking this option:
          <span className="mt-2 block space-y-2">
            {hasPipes && (
              <span className="flex items-center gap-2">
                <Package className="h-4 w-4" />
                <span>Pipe details and specifications</span>
              </span>
            )}
            {hasDocuments && (
              <span className="flex items-center gap-2">
                <FileText className="h-4 w-4" />
                <span>Associated documents</span>
              </span>
            )}
          </span>
        </>
      }
    />
  );
}; 